import { HttpErrorResponse } from '@angular/common/http';
import { AfterViewInit, Component, Inject, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogConfig,
  MatDialogRef
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ICliente } from '@app/modules/cliente/models/cliente.model';
import { IPreCadastro } from '@app/modules/cliente/models/pre_cadastro.model';
import { ClienteService } from '@app/modules/cliente/services/cliente.service';
import { PreCadastroService } from '@app/modules/cliente/services/pre_cadastro.service';
import { IParceiro } from '@app/modules/parceiro/model';
import { ParceiroService } from '@app/modules/parceiro/services/parceiro.service';
import {
  ICarteira,
  IVendedor
} from '@app/modules/vendedor/models/vendedor.model';
import { VendedorService } from '@app/modules/vendedor/services/vendedor.service';
import {
  ConfirmDialogComponent,
  ConfirmDialogData
} from '@app/shared/components';
import { Dialog } from 'primeng/dialog';
import { zip } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import {
  ErroMessages,
  IErroMessages,
  TokenService
} from 'viggo-sistemas-core-web';
import { Utils } from '../../../../shared/helpers/utils';
import { FastContatoComponent } from '../fast-contato/fast-contato.component';
import { FastEnderecoComponent } from '../fast-endereco/fast-endereco.component';
import { FastParceiroComponent } from '../fast-parceiro/fast-parceiro.component';

@Component({
  selector: 'app-fast-cliente',
  templateUrl: './fast-cliente.component.html',
  styleUrls: ['./fast-cliente.component.scss'],
  providers: [
    ClienteService,
    ParceiroService,
    PreCadastroService,
    VendedorService
  ]
})
export class FastClienteComponent implements AfterViewInit {
  @ViewChild('fastCliente') fastCliente: Dialog;
  @ViewChild(FastParceiroComponent)
  _fastParceiro: FastParceiroComponent<ICliente>;

  @ViewChild(FastEnderecoComponent)
  public _fastEndereco: FastEnderecoComponent;

  @ViewChild(FastContatoComponent)
  public _fastContato: FastContatoComponent;

  form: UntypedFormGroup;

  viewInit = false;

  notRequired = true;

  vendedor = null as IVendedor;

  // entity: ICliente = {
  //   parceiro: {
  //     contatos: [],
  //     enderecos: []
  //   } as IParceiro
  // } as ICliente;

  entity: IPreCadastro = {
    domain_id: this.tokenService.getDomain().id,
    cliente: { parceiro: {} }
  } as IPreCadastro;

  constructor(
    public dialogRef: MatDialogRef<FastClienteComponent>,
    public entityService: ClienteService,
    private tokenService: TokenService,
    protected preCadastroService: PreCadastroService,
    private parceiroService: ParceiroService,
    private vendedorService: VendedorService,
    public matSnackBar: MatSnackBar,
    public matDialog: MatDialog,
    public router: Router,
    private fb: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA)
    private data: { entity: IPreCadastro; vendedor?: IVendedor }
  ) {
    this.entity = this.data.entity;
    if (this.data.vendedor) {
      this.vendedor = this.data.vendedor;
      delete this.vendedor.settings;
    }
  }

  clearInfoParceiro() {
    this.entity.cliente.parceiro.id = undefined;
    this.entity.cliente.parceiro.contatos = this.entity.cliente.parceiro.contatos.map(
      it => {
        return {
          ...it,
          id: undefined
        };
      }
    );
    this._fastContato.updateValues(this.entity.cliente.parceiro);
  }

  public setInformacoesParceiro(
    parceiro: IParceiro = { contatos: [], enderecos: [] } as IParceiro
  ): void {
    this.entity.cliente.parceiro = parceiro;
    this._fastEndereco.updateFormValue(parceiro.enderecos);
    this._fastContato.updateValues(parceiro);
  }

  get formValid(): boolean {
    return (
      this.viewInit &&
      this._fastEndereco.form.valid &&
      this._fastParceiro.form.valid
    );
  }

  get formAddressValid(): boolean {
    if (this.viewInit && this._fastEndereco.form.invalid)
      this._fastEndereco.form.markAllAsTouched();
    return this.viewInit && this._fastEndereco.form.invalid;
  }

  get formDadosValid() {
    if (this.viewInit && this._fastParceiro.form.invalid)
      this._fastParceiro.form.markAllAsTouched();
    return this.viewInit && this._fastParceiro.form.invalid;
  }

  onSubmit(): void {
    var entity: IPreCadastro = Utils.clearObject<IPreCadastro>({
      ...this.entity,
      domain_id: this.tokenService.getDomain().id,
      cliente: {
        ...this.entity.cliente,
        parceiro: Utils.clearObject({
          ...this.entity.cliente.parceiro,
          ...this._fastParceiro.getValues(),
          saldo_credito: undefined,
          user_id: undefined,
          enderecos: this._fastEndereco.getValues(),
          contatos: this._fastContato.getValues()
        })
      }
    } as IPreCadastro);
    entity.cliente.parceiro = Utils.trimAttributes(entity.cliente.parceiro);
    entity.cliente.parceiro = Utils.clearEmptyString(entity.cliente.parceiro);
    this.insert(entity);
  }

  insertPreCadastro(entity: IPreCadastro): void {
    this.preCadastroService.insert(entity).subscribe(
      precadastro => {
        this.matSnackBar.open('Cliente criado com sucesso.', 'X', {
          duration: 2000,
          horizontalPosition: 'right',
          verticalPosition: 'top',
          panelClass: ['msg-success']
        });
        if (this.vendedor) {
          this.vendedor.carteira.push({
            pre_cadastro_id: precadastro.id
          } as ICarteira);
          this.vendedorService
            .update({ ...this.vendedor, parceiro: undefined })
            .subscribe(
              v => {
                this.dialogRef.close(precadastro);
              },
              (err: HttpErrorResponse) => this.displayError(err)
            );
        } else this.dialogRef.close(precadastro);
      },
      (err: HttpErrorResponse) => this.displayError(err)
    );
  }

  insert(entity: IPreCadastro): void {
    var preCadastro = {
      domain_id: entity.domain_id,
      nome_razao_social:
        entity.cliente.parceiro.apelido_nome_fantasia &&
        entity.cliente.parceiro.apelido_nome_fantasia.length != 0
          ? entity.cliente.parceiro.apelido_nome_fantasia
          : entity.cliente.parceiro.nome_razao_social,
      observacao: this._fastParceiro.getObservacaoValue()
    } as IPreCadastro;
    if (entity.cliente.parceiro.cpf_cnpj) {
      if (entity.cliente.parceiro.id) {
        this.preCadastroService.insert(preCadastro).subscribe(
          precadastro => {
            zip(
              this.parceiroService.update({
                ...entity.cliente.parceiro
              }),
              this.entityService.insert({
                ...entity.cliente,
                id: entity.cliente.parceiro.id,
                domain_id: entity.domain_id,
                parceiro: undefined,
                pre_cadastro_id: precadastro.id
              })
            )
              .pipe(
                mergeMap(([, cliente]) => {
                  return this.preCadastroService.getEntity(precadastro.id);
                })
              )
              .subscribe(
                precadastro => {
                  this.matSnackBar.open('Cliente criado com sucesso.', 'X', {
                    duration: 2000,
                    horizontalPosition: 'right',
                    verticalPosition: 'top',
                    panelClass: ['msg-success']
                  });
                  if (this.vendedor) {
                    this.vendedor.carteira.push({
                      pre_cadastro_id: precadastro.id
                    } as ICarteira);
                    this.vendedorService
                      .update({ ...this.vendedor, parceiro: undefined })
                      .subscribe(
                        v => {
                          this.dialogRef.close(precadastro);
                        },
                        (err: HttpErrorResponse) => this.displayError(err)
                      );
                  } else this.dialogRef.close(precadastro);
                },
                (err: HttpErrorResponse) => this.displayError(err)
              );
          },
          (err: HttpErrorResponse) => this.displayError(err)
        );
      } else {
        this.preCadastroService.insert(preCadastro).subscribe(
          precadastro => {
            this.parceiroService
              .insert({
                ...entity.cliente.parceiro,
                domain_id: this.tokenService.getDomain().id
              })
              .pipe(
                mergeMap(parceiro => {
                  return this.entityService.insert({
                    ...entity.cliente,
                    id: parceiro.id,
                    domain_id: entity.domain_id,
                    parceiro: undefined,
                    pre_cadastro_id: precadastro.id
                  });
                })
              )
              .subscribe(
                () => {
                  this.matSnackBar.open('Cliente criado com sucesso.', 'X', {
                    duration: 2000,
                    horizontalPosition: 'right',
                    verticalPosition: 'top',
                    panelClass: ['msg-success']
                  });
                  if (this.vendedor) {
                    this.vendedor.carteira.push({
                      pre_cadastro_id: precadastro.id
                    } as ICarteira);
                    this.vendedorService
                      .update({ ...this.vendedor, parceiro: undefined })
                      .subscribe(
                        v => {
                          this.dialogRef.close(precadastro);
                        },
                        (err: HttpErrorResponse) => this.displayError(err)
                      );
                  } else this.dialogRef.close(precadastro);
                },
                (err: HttpErrorResponse) => this.displayError(err)
              );
          },
          (err: HttpErrorResponse) => this.displayError(err)
        );
      }
    } else this.insertPreCadastro(preCadastro);
  }

  ngAfterViewInit(): void {
    this.viewInit = true;
    this.fastCliente.maximize();
  }

  displayError(err: HttpErrorResponse, showDefaultMsg = false) {
    const errorMsg = new ErroMessages({
      route: this.router.url,
      router: this.router,
      matSnackBar: this.matSnackBar,
      httpError: err,
      showDefaultMsg: showDefaultMsg,
      loginService: null,
      tokenService: this.tokenService,
      dialogComponent: ConfirmDialogComponent,
      matDialog: this.matDialog,
      dialogData: {
        config: {
          data: {
            title: 'Aviso - Erro ao realizar operação',
            bodyMessage: err.error,
            icon: 'warning',
            icon_color: 'accent',
            singleBtn: true
          } as ConfirmDialogData,
          disableClose: true,
          width: '500px'
        } as MatDialogConfig<any>
      }
    } as IErroMessages);
    errorMsg.showMessageObject(err.error);
    // errorMsg.checkError();
  }
}
